import * as React from 'react';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage.js';

/* eslint-disable @typescript-eslint/no-explicit-any */

var RadioButton = props => {
  var attributes = {
    className: 'form-check-input',
    id: props.id,
    type: 'radio'
  };

  // When "name" is not provided, it defaults to the value of "id"
  attributes.name = typeof props.name !== 'undefined' ? props.name : props.id;

  // When "value" is not provided, it defaults to the value of "id"
  attributes.value = typeof props.value !== 'undefined' ? props.value : props.id;

  // Handle error state
  var ErrorMessageComponent;
  if (props.isValid === false) {
    // Invalid
    attributes.className += ' is-invalid';
    attributes['aria-invalid'] = true;

    // Invalid with error message
    /* eslint-disable react/prop-types */
    if (props.errormessage) {
      attributes['aria-describedby'] = "".concat(props.id, "-errormessage");
      ErrorMessageComponent = /*#__PURE__*/React.createElement(ErrorMessage, {
        id: props.id,
        message: props.errormessage
      });
    } /* eslint-enable react/prop-types */
    // Invalid in checkbox list
    else if (props.ariaDescribedBy) {
      attributes['aria-describedby'] = props.ariaDescribedBy;
    }
  }

  // Allow checkboxes to be arranged horizontally
  var wrapperClassName = 'form-check';
  if (props.inline) {
    wrapperClassName += ' form-check-inline';
  }

  // Add the onChange handler
  if (typeof props.onChange === 'function') {
    attributes.onChange = e => {
      var {
        name
      } = e.target;
      var {
        value
      } = e.target;

      // @ts-ignore
      props.onChange(name, value, e);
    };
    attributes.checked = props.checked;
  } else {
    attributes.defaultChecked = props.checked;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName
  }, /*#__PURE__*/React.createElement("input", attributes), /*#__PURE__*/React.createElement("label", {
    className: "form-check-label",
    htmlFor: props.id
  }, /*#__PURE__*/React.createElement("span", {
    className: "form-check-label-text"
  }, props.label, props.labelSecondary && /*#__PURE__*/React.createElement("span", {
    className: "form-check-label-text-secondary"
  }, props.labelSecondary))), ErrorMessageComponent);
};
RadioButton.defaultProps = {
  checked: false
};

export { RadioButton };
